import React, { useState, useEffect } from "react";
import { DeleteCharge } from "../../pages";
import { ChargeController } from "../../controllers";
import { toJS } from "mobx";
import { chargeStore } from "../../stores";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";

const DeleteChargeContainer = ({ closeModal, data }) => {
    const [loading, setLoading] = useState(false);

    const handleDelete = async (data) => {
        setLoading(true);
        const { status, errorMessage } = await ChargeController.deleteCharge(data);
        if (status === constant.Success) {
            ChargeController.getCharges();
            MimaToastUtil.success({ message: constant.Success })
            setLoading(false);
            return closeModal();
        } else {
            setLoading(false);
            MimaToastUtil.error({ message: errorMessage })
        }
    }

    return (
        <DeleteCharge
            closeModal={closeModal}
            loading={loading}
            handleDelete={handleDelete}
            data={data}
        />
    )
}
export default DeleteChargeContainer;